import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    row: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      marginTop: 10,
      textAlign: "left",
      [theme.breakpoints.up("mobile")]: {
        justifyContent: "space-between",
      },
    },
    placeholder: {
      width: 120,
      [theme.breakpoints.up("mobile")]: {
        display: "inline-block",
      },
    },
    imagePlaceholder: {
      display: "inline-block",
      position: "absolute",
      zIndex: "1",
      top: "0",
      left: "0",
      width: 60,
      height: 60,
    },
    service: {
      position: "relative",
      "& img": {
        position: "relative",
        width: 60,
        height: 60,
        marginRight: 10,
        verticalAlign: "middle",
        zIndex: "2",
        "&::before": {
          display: "inline-block",
          width: 60,
        },
      },
    },
  }),
  { name: "PlaceholderIdentity" },
);
